module.exports = __webpack_public_path__ + "973857bd72.svg";